/**
 * @fileoverview Tenant activity types.
 * @description The kinds of activity a salesperson can log against a bank, in the order the Add
 * Activity form offers them, and each one's translation key under
 * `sales.tenantDetail.activities.types`.
 * @copyright Copyright (c) 2026 Brownbox Consulting. All rights reserved.
 * @author Rahul Chawda
 */

import type { ActivityType } from '@/features/sales/types/tenant.types'

export const ACTIVITY_TYPES: ActivityType[] = ['Call', 'Meeting', 'Demo', 'Note', 'Follow-up']

/** Each activity type's key under `sales.tenantDetail.activities.types`. */
export const ACTIVITY_TYPE_KEY: Record<ActivityType, string> = {
  Call: 'call',
  Meeting: 'meeting',
  Demo: 'demo',
  Note: 'note',
  'Follow-up': 'followUp',
}
